export default (url, onProgress = () => {}, total = 0, insertRequest=null) => {
    return new Promise((resolve, reject) => {
        var req = new XMLHttpRequest();
        if (insertRequest){
            insertRequest(req);
        }
        req.open('GET', url, true);
        req.responseType = 'blob';

        req.onprogress = e => {
            const t = e.total || total;
            onProgress(e.loaded / t * 100);
        };

        req.onload = () => {
            if (req.status === 200) {
                resolve(URL.createObjectURL(req.response)); // IE10+
            } else {
                reject(new Error(`${req.status} while downloading resource`));
            }
        };

        req.onerror = e => {
            reject(e);
        };

        req.onabort = e => {};

        req.send();
    });
}


// WEBPACK FOOTER //
// ./src/js/utils/loader.js